var map = {
	"./atari-2600.json": [
		"9ad7",
		"chunk-2d0f0291"
	],
	"./bootstrap.json": [
		"22ee",
		"chunk-2d0b23d6"
	],
	"./cga.json": [
		"ed2f",
		"chunk-2d230849"
	],
	"./commodore-64.json": [
		"a1ae",
		"chunk-2d207d0a"
	],
	"./html-names.json": [
		"6ea7",
		"chunk-2d0db41b"
	],
	"./material.json": [
		"56e2",
		"chunk-2d0c8fc4"
	],
	"./vlavaav.json": [
		"759a",
		"chunk-2d0d6f9c"
	],
	"./websafe-colors.json": [
		"8c1c",
		"chunk-2d0e8fb3"
	],
	"./zx-spectrum.json": [
		"d486",
		"chunk-2d21e044"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a341";
module.exports = webpackAsyncContext;